import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react"
import Slider, { Settings, CustomArrowProps } from 'react-slick'
import { Container } from "./styles"
import { DealershipWarning, NewCalendar, PartnerNews, ReferralLinkCard } from "./components"
import { useTheme } from "@emotion/react"
import { useAuth } from "~/contexts"

export const EmphasisBanners: React.FC = () => {
  const theme = useTheme()
  const { authUser } = useAuth()

  const banners = [
    <ReferralLinkCard key='banner-referral' arrowColor={theme.palette.primary.main} />,
    <PartnerNews key='banner-news' arrowColor={theme.palette.secondary.main} />,
    ...(authUser?.owner ? [<NewCalendar key='banner-calendar' arrowColor={theme.palette.secondary.main} />] : []),
    <DealershipWarning key='banner-warning' arrowColor={theme.palette.primary.main} />,
  ]

  const SampleNextArrow = (props: CustomArrowProps) => {
    const { className, onClick, currentSlide } = props
    const color = (banners[(currentSlide ?? 0)] as any)?.props?.arrowColor || theme.palette.primary.main
    return (
      <button
        className={className}
        onClick={onClick}
      >
        <IconChevronRight size={24} color={color} />
      </button>
    )
  }

  const SamplePrevArrow = (props: CustomArrowProps) => {
    const { className, onClick, currentSlide } = props
    const color = (banners[(currentSlide ?? 0)] as any)?.props?.arrowColor || theme.palette.primary.main
    return (
      <button
        className={className}
        onClick={onClick}
      >
        <IconChevronLeft size={24} color={color} />
      </button>
    )
  }

  const settings: Settings = {
    arrows: true,
    infinite: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 5000,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    verticalSwiping: false,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    dots: false,
  }

  return (
    <Container>
      <Slider {...settings}>
        {banners as any}
      </Slider>
    </Container>
  )
}
